// Environment variables utility
// This helps with type safety and default values

// IMPORTANT: For static exports with token substitution:
// - Build-time: Use #{TOKEN_*}# placeholders that get baked into the bundle
// - Release-time: Replace these tokens with actual values in the release pipeline

// Log environment variables for debugging
if (typeof window !== "undefined") {
  console.log("Client-side environment variables:")
  console.log("NEXT_PUBLIC_API_URL:", process.env.NEXT_PUBLIC_API_URL)
  console.log("NEXT_PUBLIC_ADMIN_SERVICE_API_ENDPOINT:", process.env.NEXT_PUBLIC_ADMIN_SERVICE_API_ENDPOINT)
  console.log("NEXT_PUBLIC_USE_MOCK_DATA:", process.env.NEXT_PUBLIC_USE_MOCK_DATA)
  console.log("NEXT_PUBLIC_BASE_PATH:", process.env.NEXT_PUBLIC_BASE_PATH)
  console.log("NEXT_PUBLIC_BUILD_ENV:", process.env.NEXT_PUBLIC_BUILD_ENV)
}

// Application environment variables
// These will be token placeholders at build time, replaced in release pipeline
export const env = {
  // API URL for backend services
  apiUrl: process.env.NEXT_PUBLIC_API_URL || "#{API_URL}#",

  // Admin Service API Endpoint
  adminServiceApiEndpoint: process.env.NEXT_PUBLIC_ADMIN_SERVICE_API_ENDPOINT || "#{ADMIN_SERVICE_API_ENDPOINT}#",

  // Whether to use mock data instead of real API calls
  useMockData: process.env.NEXT_PUBLIC_USE_MOCK_DATA || "#{USE_MOCK_DATA}#",

  // Build environment
  buildEnv: process.env.NEXT_PUBLIC_BUILD_ENV || "#{BUILD_ENV}#",

  // Base path
  basePath: process.env.NEXT_PUBLIC_BASE_PATH || "#{BASE_PATH}#",
}

// Log the final env object for debugging
if (typeof window !== "undefined") {
  console.log("Final env object:", env)
}
